import React from 'react'
import styles from './styles.css'
import { Form, Field } from 'simple-react-form'
import Signers from 'App/components/fields/Signers'
import SignersByRoles from 'App/components/fields/SignersByRoles'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import Toggle from 'orionsoft-parts/lib/components/fields/Toggle'
import { withRouter } from 'react-router'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import MdPeople from 'react-icons/lib/md/people'
import includes from 'lodash/includes'
import VerifyAlert from 'App/components/VerifyAlert'
import isAdmin from 'App/Decorators/isAdmin'

@isAdmin
@withGraphQL(
  gql`
    query getMyPendingDocuments {
      me {
        _id
        emails {
          address
        }
      }
    }
  `
)
@withMutation(gql`
  mutation updateDocumentSigners(
    $documentId: ID
    $signers: [SignerInput]
    $requireSignersOrder: Boolean
    $organizationId: ID
  ) {
    updateDocumentSigners(
      documentId: $documentId
      signers: $signers
      requireSignersOrder: $requireSignersOrder
      organizationId: $organizationId
    ) {
      _id
      requireSignersOrder
      signatureRequested
      signers {
        name
        email
      }
    }
  }
`)
@withMutation(gql`
  mutation automaticSend($documentId: ID, $signers: [SignerInput]) {
    automaticSend(documentId: $documentId, signers: $signers) {
      success
    }
  }
`)
@withMutation(gql`
  mutation requestDocumentSignature($documentId: ID) {
    requestDocumentSignature(documentId: $documentId) {
      _id
      signatureRequested
    }
  }
`)
@withMutation(gql`
  mutation resendVerificationEmail($email: String) {
    resendVerificationEmail(email: $email) {
      success
    }
  }
`)
@withMutation(gql`
  mutation sendEmailViewer($documentId: ID) {
    sendEmailViewer(documentId: $documentId) {
     success
    }
  }
`)
@withRouter
@withMessage
export default class UpdateSigners extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    document: PropTypes.object,
    updateDocumentSigners: PropTypes.func,
    automaticSend: PropTypes.func,
    requestDocumentSignature: PropTypes.func,
    me: PropTypes.func,
    organization: PropTypes.object,
    admin: PropTypes.string,
    url: PropTypes.bool,
    params: PropTypes.object,
    sendEmailViewer: PropTypes.func
  }

  static fragment = gql`
    fragment documentUpdateInformation on Document {
      name
      description
      fromTemplate
    }
  `

  state = {}

  async sendEmail() {
    this.setState({ loading: true, errorMessages: null })
    try {
      await this.props.resendVerificationEmail({
        email: this.props.me.emails.address
      })
      this.props.showMessage('Email de confirmación enviado a tu correo.')
    } catch (error) {
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  renderAlert() {
    return <VerifyAlert onClick={() => this.sendEmail()} ref="alert" />
  }

  @autobind
  async saveSend({ signers }) {
    this.setState({ loading: true })
    try {
      await this.props.automaticSend(
        {
          documentId: this.props.document._id,
          signers
        },
        {
          refetchQueries: [
            'getDocument',
            'document',
            'myDocumentsToSign',
            'myFeaDocumentsToSign',
            'documents',
            'documentCount',
            'planSignaturesCount',
            'packsSignaturesCount'
          ]
        }
      )
      await this.props.sendEmailViewer({documentId: this.props.document._id})
      window.scrollTo(0, 0)
      this.props.showMessage('Success')
    } catch (error) {
      console.log('Error:', error)
      if (includes(error.message, 'verify')) {
        this.refs.alert.toggleDialog('OutlineModal')
      } else {
        this.props.showMessage(error.message, { level: 'error' })
      }
    }
    this.setState({ loading: false })
  }

  // Send email to the users
  @autobind
  async save({ signers, requireSignersOrder }) {
    this.setState({ loading: true })
    try {
      await this.props.updateDocumentSigners(
        {
          documentId: this.props.document._id,
          signers,
          requireSignersOrder,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['getDocument']
        }
      )
      this.props.showMessage('Success')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  changeForm(state) {
    this.setState(state)
  }

  buttonsAppear() {
    if (
      (!this.props.url && this.props.document.documentOwner) ||
      (this.props.organization && this.props.organization.myRole === 'owner')
    ) {
      return true
    }
    return false
  }

  renderSignersRoles() {
    return (
      <div className={styles.container}>
        <Form
          ref={form => {
            this.form = form
          }}
          state={this.props.document}
          onSubmit={this.saveSend}
          onChange={state => this.changeForm(state)}
        >
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-10">
                  <h3 className={styles.title}>Firmantes
                  { this.props.document.requireSignersOrder === true ?
                      (  " ( Firmas deben ser en orden )" ): "" 
                  }
                  
                  </h3>
                </div>
                <div className="col-xs-12 col-sm-2 end-md">
                  <div className={styles.icon}>
                    <MdPeople size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <Field
                fieldName="signers"
                type={
                  typeof this.props.document.fromTemplate !== 'undefined'
                    ? SignersByRoles
                    : Signers
                }
                signersRoles={this.props.document.signersRoles}
                autoAdd={false}
                owner={this.props.document.documentOwner}
              />
              <br />
              {this.buttonsAppear() ? (
                <div className={styles.button}>
                  <Button
                    primary
                    loading={this.state.loading}
                    onClick={() => this.form.submit()}
                  >
                    Guardar y enviar
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        </Form>
        {this.renderAlert()}
      </div>
    )
  }

  renderSigners() {
    return (
      <div className={styles.container}>
        <Form
          ref={form => {
            this.form = form
          }}
          state={this.props.document}
          onSubmit={this.save}
          onChange={state => this.changeForm(state)}
        >
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-2">
                  <h3 className={styles.title}>Firmantes</h3>
                </div>
                <div className="col-xs-12 col-sm-10 end-md">
                  <div className={styles.icon}>
                    <MdPeople size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <Field
                fieldName="signers"
                draggable={this.state.requireSignersOrder}
                type={Signers}
                autoAdd={false}
                url={this.props.url}
                owner={this.props.document.documentOwner}
                organization={this.props.organization}
              />

              {this.buttonsAppear() ? (
                <div>
                  <br />{' '}
                  <Field
                    fieldName="requireSignersOrder"
                    type={Toggle}
                    label="Asignar orden a los firmantes"
                  />
                </div>
              ) : (
                ''
              )}

              {this.buttonsAppear() ? (
                <div>
                  <br />
                  <Button
                    primary
                    loading={this.state.loading}
                    onClick={() => this.form.submit()}
                  >
                    Guardar
                  </Button>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </Form>
      </div>
    )
  }

  render() {
    if (!this.props.document.fromTemplate) {
      if (!this.props.document.isPersonal) {
        return this.renderSigners()
      }
    } else {
      return this.renderSignersRoles()
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/UpdateSigners/index.js